window.downpay = window.downpay || {};

if (window.downpay.cartRefreshOn === undefined) {
  window.downpay.cartRefreshOn = true;
}

if (window.downpay.addOnApply === undefined) {
  window.downpay.addOnApply = true;
}

function fetchCart(fn) {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      fn(cart);
    });
}

function findElementByXPath(document, xpath) {
  const result = document.evaluate(
    xpath,
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null,
  );
  return result.singleNodeValue;
}

function refreshDownpayTotals() {
  fetch(window.location.href)
    .then((response) => response.text())
    .then((text) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const dueTodayXPath = findElementByXPath(doc, '//*[@id="downpay-due-today-amount"]');
      const dueLaterXPath = findElementByXPath(doc, '//*[@id="downpay-due-later-amount"]');

      if (dueTodayXPath !== null) {
        const dueTodayVal = dueTodayXPath.innerHTML.trim();
        const dueTodayElements = document.querySelectorAll('#downpay-due-today-amount');
        if (dueTodayElements.length > 0) {
          dueTodayElements.forEach((element) => {
            element.innerHTML = dueTodayVal;
          });
        }
      }

      if (dueLaterXPath !== null) {
        const dueLaterVal = dueLaterXPath.innerHTML.trim();
        const dueLaterElements = document.querySelectorAll('#downpay-due-later-amount');
        if (dueLaterElements.length > 0) {
          dueLaterElements.forEach((element) => {
            element.innerHTML = dueLaterVal;
          });
        }
      }
    });
}

function recheckCartTotals(period) {
  let no_change_count = 0;
  let interval = period;
  let item_count, total_price, items_with_options;

  fetchCart((cart) => {
    item_count = cart.item_count;
    total_price = cart.total_price;
    items_with_options = cart.items.filter((item) => item.selling_plan_allocation);
  });

  function retryCart() {
    fetchCart((cart) => {
      if (
        cart.item_count !== item_count ||
        cart.total_price !== total_price ||
        cart.items.filter((item) => item.selling_plan_allocation).length !==
          items_with_options.length
      ) {
        no_change_count = 0;
        interval = period;

        //storefront caching and race conditions can cause storefront rendering to slightly lag behind the actual cart state
        setTimeout(refreshDownpayTotals, 500);

        item_count = cart.item_count;
        total_price = cart.total_price;
        items_with_options = cart.items.filter((item) => item.selling_plan_allocation);
      } else {
        no_change_count++;
      }

      // gradually backs off if there are no cart changes, but resets if any changes are detected
      if (no_change_count % 4 === 0) {
        interval = Math.min(interval * 2, 4000);
      }

      setTimeout(retryCart, interval);
    });
  }
  retryCart();
}

// fetch: https://stackoverflow.com/a/64241104/438417
// load: https://stackoverflow.com/a/63505699/438417
function listenToQuantityUpdates(ns, fetch) {
  listenToCartCallsMadeWithFetch(ns, fetch);
  listenToCartCallsMadeWithXMLHttpRequest();
}

function listenToCartCallsMadeWithFetch(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function () {
    const response = fetch.apply(this, arguments);

    response.then((res) => {
      if (
        [
          `${window.location.origin}/cart/add.js`,
          `${window.location.origin}/cart/update.js`,
          `${window.location.origin}/cart/change.js`,
          `${window.location.origin}/cart/clear.js`,
          `${window.location.origin}/cart/add`,
          `${window.location.origin}/cart/update`,
          `${window.location.origin}/cart/change`,
          `${window.location.origin}/cart/clear`,
        ].includes(res.url)
      ) {
        res
          .clone()
          .json()
          .then((_data) => refreshDownpayTotals());
      }
    });

    return response;
  };
}

function listenToCartCallsMadeWithXMLHttpRequest() {
  const open = window.XMLHttpRequest.prototype.open;

  function openReplacement() {
    this.addEventListener('load', function () {
      if (
        [
          '/cart/add.js',
          '/cart/update.js',
          '/cart/change.js',
          '/cart/clear.js',
          '/cart/add',
          '/cart/update',
          '/cart/change',
          '/cart/clear',
        ].includes(this._url)
      ) {
        refreshDownpayTotals();
      }
    });
    return open.apply(this, arguments);
  }

  window.XMLHttpRequest.prototype.open = openReplacement;
}

listenToQuantityUpdates(window, window.fetch);
recheckCartTotals(250);
